// getUserMedia helpers for the browser streaming engine (web-only module —
// only ever imported from .web.js files).

export const TARGET = { width: 1280, height: 720, frameRate: 30 };

export async function listDevices() {
  const devices = await navigator.mediaDevices.enumerateDevices();
  return {
    cameras: devices.filter((d) => d.kind === "videoinput"),
    mics: devices.filter((d) => d.kind === "audioinput"),
  };
}

export async function acquireStream({ videoDeviceId, audioDeviceId } = {}) {
  const fullVideo = {
    width: { ideal: TARGET.width },
    height: { ideal: TARGET.height },
    frameRate: { ideal: TARGET.frameRate },
    ...(videoDeviceId ? { deviceId: { exact: videoDeviceId } } : { facingMode: "user" }),
  };
  const fullAudio = {
    ...(audioDeviceId ? { deviceId: { exact: audioDeviceId } } : {}),
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
  };

  // Fallback ladder: some machines list devices that can't actually start
  // (Continuity Camera out of range, virtual cams, unplugged USB) and a
  // single constraint set then fails with NotFoundError/NotReadableError.
  // Permission denials are never retried.
  const attempts = [
    { video: fullVideo, audio: fullAudio },
    // drop exact device ids / facingMode, keep 720p preference
    {
      video: { width: { ideal: TARGET.width }, height: { ideal: TARGET.height }, frameRate: { ideal: TARGET.frameRate } },
      audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
    },
    // let the browser pick anything
    { video: true, audio: true },
  ];

  let lastError = null;
  for (const constraints of attempts) {
    try {
      return await navigator.mediaDevices.getUserMedia(constraints);
    } catch (e) {
      if (e?.name === "NotAllowedError" || e?.name === "SecurityError") throw e;
      lastError = e;
    }
  }
  throw lastError;
}

export function stopStream(stream) {
  stream?.getTracks().forEach((t) => t.stop());
}
